export default "__VITE_ASSET__ywPY0z90__"